import { toDate } from 'date-fns/toDate';

import customSet from '../../utils/dateHandling/customSet';

const ANYTIME = 'wholeyear' as const;

const pad = (number: number): string => {
  if (number < 10) {
    return `0${number}`;
  }
  return `${number}`;
};

const dateFormatRegex = /^((?:20)?[12]\d)-?([01]\d)?-?([0-3]\d)?$/;
const invalid = toDate(0);

type ParsedPartialDate = PartialDate | typeof ANYTIME;

export default class PartialDate {
  date: Date;

  constructor(date?: Date) {
    this.date = date ?? invalid;
  }

  toString(): string {
    const year = this.date.getFullYear();
    const month = this.date.getMonth();
    return `${year}-${pad(month + 1)}`;
  }

  toStringAddOneYearPlusOneMonth(): string {
    const year = this.date.getFullYear();
    const month = this.date.getMonth();
    return `${year + 1}-${pad(month + 1)}`;
  }

  static parse(dateStr: string | null | undefined): ParsedPartialDate | null {
    if (!dateStr || dateStr === '' || typeof dateStr !== 'string') {
      return null;
    }
    if (dateStr === ANYTIME) {
      return ANYTIME;
    }
    const result = dateFormatRegex.exec(dateStr.trim());
    if (!result) {
      return null;
    }
    let [, year, month, day] = result;
    if (!day) {
      day = '01';
    }
    if (!month) {
      month = '01';
    }
    if (year.length === 2) {
      year = `20${year}`;
    }
    if (Number(month) > 12) {
      return null;
    }
    const n = (str: string) => parseInt(str, 10);
    const date = customSet(n(year), n(month) - 1, n(day));
    return new PartialDate(date);
  }
}
